import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _excluded = ["jobId"];
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { action, observable, computed } from 'mobx';
import { Store } from 'libx';
import Document from './Document';
import env from '../misc/env';
import orderBy from 'lodash/orderBy';
import { DocumentAPI } from './API';
import NewDocumentState from './views/NewDocument/NewDocumentState';
import DocumentInspectorState from './views/DocumentInspector/DocumentInspectorState';
import InfiniteScrollProvider from '../data/InfiniteScrollProvider';
import { isMobile } from 'utils/mobileDetect';
var orderDocuments = function orderDocuments(docs) {
  return orderBy(docs, 'dateCreated', 'desc');
};
var DocumentStore = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _class = /*#__PURE__*/function (_Store) {
  function DocumentStore() {
    var _this;
    _classCallCheck(this, DocumentStore);
    _this = _callSuper(this, DocumentStore, arguments);
    // A view model for the view to render in the sidebar.
    // If `null`, renders nothing.
    _initializerDefineProperty(_this, "view", _descriptor, _this);
    _initializerDefineProperty(_this, "files", _descriptor2, _this);
    _initializerDefineProperty(_this, "creationOpts", _descriptor3, _this);
    _this.documents = _this.collection({
      model: Document
    });
    _this.api = new DocumentAPI({
      baseURL: env.DOCUMENT_API,
      getToken: _this.rootStore.authStore.getToken
    });
    _this.fetchUserDocuments = _this.fetchUserDocuments.bind(_this);

    // Scroll providers (for infinite scrolling and caching the results)
    _this.scrollProviders = new Map();
    _this.rootStore.authStore.onLogin(function () {
      _this.api.subscribe('DocumentUpdated', function (doc) {
        if (!doc.archived) {
          _this.documents.set(doc);
        }
      });
      _this.api.subscribe('DocumentCreated', _this.documents.set);
    });
    _this.rootStore.sessionStore.onWorkspaceSelected(function () {
      _this.documents.clear();
      _this.scrollProviders.clear();
      _this.userDocumentsScrollProvider.reset();
    });
    return _this;
  }
  _inherits(DocumentStore, _Store);
  return _createClass(DocumentStore, [{
    key: "isMobile",
    get: function get() {
      return isMobile();
    }

    /**
     * Scroll provider for the current user's own documents.
     */
  }, {
    key: "userDocumentsScrollProvider",
    get: function get() {
      return this.getScrollProvider('user', this.fetchUserDocuments);
    }
  }, {
    key: "userDocumentsScrollProviderForUserId",
    value: function userDocumentsScrollProviderForUserId(id) {
      var _this2 = this;
      return this.getScrollProvider(id, function (params) {
        return _this2.fetchUserDocuments(_objectSpread({
          user_id: id
        }, params));
      });
    }

    /**
     * Gets or inits a scroll provider.
     * A scroll provider is used to manage infinite scrolling state
     * for APIs using cursor-based paging.
     */
  }, {
    key: "getScrollProvider",
    value: function getScrollProvider(uid, fetchItems) {
      var existing = this.scrollProviders.get(uid);
      if (existing) {
        return existing;
      }
      var newProvider = new InfiniteScrollProvider({
        memoizeInitial: true,
        limit: 30,
        fetchItems: fetchItems
      });
      this.scrollProviders.set(uid, newProvider);
      return newProvider;
    }
  }, {
    key: "forJob",
    value: function forJob(jobId) {
      return orderDocuments(this.documents.filter(function (doc) {
        var access = doc.accesses.find(function (a) {
          return a.jobId === jobId;
        });
        return !!access;
      }));
    }
  }, {
    key: "forUser",
    value: function forUser(userId) {
      var _this3 = this;
      return orderDocuments(this.documents.filter(function (doc) {
        return doc.ownerId === (userId || _this3.rootStore.authStore.user.userId);
      }));
    }
  }, {
    key: "forUserAsAdmin",
    value: function forUserAsAdmin(userId) {
      return orderDocuments(this.documents.filter(function (doc) {
        return doc.ownerId === userId;
      }));
    }
  }, {
    key: "setView",
    value: function setView(view) {
      if (this.view && this.view.deactivate) {
        this.view.deactivate();
      }
      this.view = view;
      if (this.view && this.view.activate) {
        this.view.activate();
      }
    }
  }, {
    key: "closeView",
    value: function closeView() {
      this.setView(null);
      this.newDocument(this.files, this.creationOpts);
    }
  }, {
    key: "newDocument",
    value: function newDocument(files) {
      var creationOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.files = Array.from(files);
      this.creationOpts = creationOpts;
      if (files.length < 1) return;
      this.setView(new NewDocumentState({
        files: [this.files.shift()],
        access: creationOpts.access,
        workspaceId: creationOpts.workspaceId,
        createdForUserId: creationOpts.createdForUserId
      }, {
        rootStore: this.rootStore,
        close: this.closeView
      }));
    }
  }, {
    key: "viewDocument",
    value: function viewDocument(document) {
      this.setView(new DocumentInspectorState({
        document: document
      }, {
        rootStore: this.rootStore,
        close: this.closeView
      }));
    }
  }, {
    key: "fetchDocumentsForJob",
    value: function () {
      var _fetchDocumentsForJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var jobId, params;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              jobId = _ref.jobId, params = _objectWithoutProperties(_ref, _excluded);
              return _context.abrupt("return", this._query(_objectSpread({
                context: 'Job',
                job_id: jobId
              }, params)));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchDocumentsForJob(_x) {
        return _fetchDocumentsForJob.apply(this, arguments);
      }
      return fetchDocumentsForJob;
    }()
  }, {
    key: "fetchUserDocuments",
    value: function () {
      var _fetchUserDocuments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this._query(_objectSpread({
                context: 'User',
                workspace_id: this.rootStore.sessionStore.workspace.id
              }, params)));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchUserDocuments(_x2) {
        return _fetchUserDocuments.apply(this, arguments);
      }
      return fetchUserDocuments;
    }()
  }, {
    key: "fetchDocument",
    value: function () {
      var _fetchDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.api.get(id).then(this.documents.set));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchDocument(_x3) {
        return _fetchDocument.apply(this, arguments);
      }
      return fetchDocument;
    }()
  }, {
    key: "createDocument",
    value: function () {
      var _createDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
        var created;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.api.create(data);
            case 2:
              created = _context4.sent;
              return _context4.abrupt("return", this.documents.set(created));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createDocument(_x4) {
        return _createDocument.apply(this, arguments);
      }
      return createDocument;
    }()
  }, {
    key: "updateDocument",
    value: function () {
      var _updateDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, data) {
        var updated;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.api.update(id, data);
            case 2:
              updated = _context5.sent;
              return _context5.abrupt("return", this.documents.set(updated));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateDocument(_x5, _x6) {
        return _updateDocument.apply(this, arguments);
      }
      return updateDocument;
    }()
  }, {
    key: "archiveDocument",
    value: function () {
      var _archiveDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.api.archive(id);
            case 2:
              return _context6.abrupt("return", this.documents.remove(id));
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function archiveDocument(_x7) {
        return _archiveDocument.apply(this, arguments);
      }
      return archiveDocument;
    }()
  }, {
    key: "assignType",
    value: function () {
      var _assignType = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id, type) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.api.assignType(id, {
                type: type
              }).then(this.documents.set);
            case 2:
              return _context7.abrupt("return", _context7.sent);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function assignType(_x8, _x9) {
        return _assignType.apply(this, arguments);
      }
      return assignType;
    }()
  }, {
    key: "download",
    value: function download(document, inline, version, file) {
      version = version || document.latestVersion;
      file = file || version && version.files[0];
      if (!file) {
        return;
      }
      this._download(document.id, version.id, file.id, inline);
    }
  }, {
    key: "zip",
    value: function () {
      var _zip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(documents) {
        var _this4 = this;
        var payload, zipCreated, ephemeralDocDto, zipDoc;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              payload = documents.filter(function (d) {
                return d.latestVersion;
              }).flatMap(function (doc) {
                return doc.latestVersion.files.map(function (f) {
                  return {
                    document_id: doc.id,
                    version_id: doc.latestVersion.id,
                    file_id: f.id
                  };
                });
              });
              zipCreated = new Promise(function (resolve) {
                var unsub = _this4.api.subscribe('ZipCreated', function (zipDoc) {
                  if (zipDoc.document_id === ephemeralDocDto.id) {
                    resolve(zipDoc);
                    unsub();
                  }
                });
              });
              _context8.next = 4;
              return this.api.zipFiles(payload);
            case 4:
              ephemeralDocDto = _context8.sent;
              _context8.next = 7;
              return zipCreated;
            case 7:
              zipDoc = _context8.sent;
              _context8.next = 10;
              return this._download(zipDoc.document_id, zipDoc.version_id, zipDoc.file_id, false);
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function zip(_x10) {
        return _zip.apply(this, arguments);
      }
      return zip;
    }()
  }, {
    key: "_download",
    value: function _download(documentId, versionId, fileId, inline) {
      // The trick is to submit a POST form to the download
      // endpoint, that way the browser won't block it as a popup and we
      // can safely transfer the auth token.
      var url = "".concat(env.DOCUMENT_API_EXTERNAL, "/v3/documents/").concat(documentId, "/versions/").concat(versionId, "/download/").concat(fileId, "?preview=").concat(inline);
      var form = window.document.createElement('form');
      form.action = url;
      form.method = 'post';
      form.target = '_blank';
      var input = window.document.createElement('input');
      input.type = 'hidden';
      input.name = '__authorization';
      input.value = "Bearer ".concat(this.rootStore.authStore.token);
      form.appendChild(input);
      window.document.body.appendChild(form);
      form.submit();
      window.document.body.removeChild(form);
    }
  }, {
    key: "_query",
    value: function () {
      var _query2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(query) {
        var paged;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.api.find(_objectSpread(_objectSpread({}, query), {}, {
                accesses: true,
                history: true,
                tags: true
              }));
            case 2:
              paged = _context9.sent;
              return _context9.abrupt("return", _objectSpread(_objectSpread({}, paged), {}, {
                data: this.documents.set(paged.data)
              }));
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function _query(_x11) {
        return _query2.apply(this, arguments);
      }
      return _query;
    }()
  }, {
    key: "canLinkExistingDocuments",
    get: function get() {
      var _workspaceConfig$job_, _workspaceConfig$job_2;
      var workspaceConfig = this.rootStore.sessionStore.workspace.config;
      return (_workspaceConfig$job_ = (_workspaceConfig$job_2 = workspaceConfig.job_details_config) === null || _workspaceConfig$job_2 === void 0 ? void 0 : _workspaceConfig$job_2['documents.allow_linking']) !== null && _workspaceConfig$job_ !== void 0 ? _workspaceConfig$job_ : true;
    }
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "view", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "files", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "creationOpts", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setView", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "setView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeView", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "closeView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "newDocument", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "newDocument"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewDocument", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "viewDocument"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canLinkExistingDocuments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canLinkExistingDocuments"), _class.prototype), _class);
export { DocumentStore as default };
//# sourceMappingURL=DocumentStore.js.map
